import { render, staticRenderFns } from "./MbGamesGridElectron.vue?vue&type=template&id=2bd5cb74&"
import script from "./MbGamesGridElectron.vue?vue&type=script&lang=js&"
export * from "./MbGamesGridElectron.vue?vue&type=script&lang=js&"
import style0 from "./MbGamesGridElectron.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports